import "./SearchPageTipsAndFuzzy.scss";
import { CaretDownIcon, ContentArea } from "/App.Components";
import { useState } from "react";
import { ContentAreaType } from "/Models/Generated/ContentAreaType";
import { ContentAreaProps } from "/Models/Generated/ContentAreaProps";
import Checkbox from "../../Shared/Checkbox/Checkbox";
import cn from "classnames";

interface Props {
  enableFuzzySearch?: boolean;
  fuzzySearchLabel?: string;
  searchTipsLabel?: string;
  searchTips?: ContentAreaProps;
  setLoading: (loading: boolean) => void;
  fuzzy: boolean;
  setFuzzy: (fuzzy: boolean) => void;
  setPageNumber: (pageNumber: number) => void;
}

const SearchPageTipsAndFuzzy = ({
  enableFuzzySearch,
  fuzzySearchLabel,
  searchTipsLabel,
  searchTips,
  setLoading,
  fuzzy,
  setFuzzy,
  setPageNumber,
}: Props) => {
  const [searchTipsOpen, setSearchTipsOpen] = useState(false);

  const showTipsAndFuzzy =
    enableFuzzySearch || !!(searchTips && searchTipsLabel);

  if (!showTipsAndFuzzy) {
    return null;
  }
  return (
    <div className="search-page-tips-and-fuzzy">
      <div className="search-page-tips-and-fuzzy__top-bar">
        <div className="search-page-tips-and-fuzzy__tips-container">
          {!!(searchTips && searchTipsLabel) && (
            <button
              className="search-page-tips-and-fuzzy__expander"
              onClick={() => setSearchTipsOpen(!searchTipsOpen)}
            >
              <div
                className={cn("search-page-tips-and-fuzzy__icon-container", {
                  "search-page-tips-and-fuzzy__icon-container--rotated":
                    searchTipsOpen,
                })}
              >
                <CaretDownIcon size="24" thickness="Reg" />
              </div>
              <span className="search-page-tips-and-fuzzy__search-tips-label">
                {searchTipsLabel}
              </span>
            </button>
          )}
          {searchTipsOpen && (
            <div className="search-page-tips-and-fuzzy__search-tips">
              <ContentArea
                {...searchTips}
                contentAreaType={ContentAreaType.RichText}
                richText={{ theme: "searchtips" }}
              />
            </div>
          )}
        </div>
        <div className="search-page-tips-and-fuzzy__search-box">
          {enableFuzzySearch && (
            <Checkbox
              label={fuzzySearchLabel ?? ""}
              name="fuzzy-search-checkbox"
              checked={fuzzy}
              onClick={() => {
                setPageNumber(1);
                setFuzzy(!fuzzy);
                setLoading(true);
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default SearchPageTipsAndFuzzy;
